<template>
  <div class="bubble">
    <div class="color" :style="{backgroundColor: '#dadada'}"></div>

    <div class="name">
      <div v-for="bubble in intersection.bubbles" :key="bubble.id">{{ bubble.name }}</div>
    </div>

    <div class="users">
      <span class="tag">
        <font-awesome-icon icon="users"></font-awesome-icon>&nbsp;&nbsp;{{ intersection.intersectioncount }}
      </span>
    </div>

    <k-dropdown>
      <template slot="handler">
        <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
      </template>
      <k-dropdown-option @click.native="save">Save</k-dropdown-option>
      <k-dropdown-option @click.native="exportCSV">Export</k-dropdown-option>
    </k-dropdown>

    <div class="loading-actions"  v-if="loadingExport">
      <font-awesome-icon class="loader-cog" icon="cog" spin></font-awesome-icon>
    </div>
  </div>
</template>

<script>
import HTTP from '@rocketfid/api'
import { mapActions } from 'vuex'

export default {
  name: 'bubble-intersection',

  props: {
    intersection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      openEdition: false,
      openTriggerEvent: false,
      openMessageForm: false,
      loadingExport: false
    }
  },

  methods: {
    ...mapActions('bubbles', ['addBubbleFromIntersection']),

    save () {
      let title = ''
      this.intersection.bubbles.forEach((bubble) => {
        title += (title ? ' - ' + bubble.name : bubble.name)
      })
      let bubble = {
        name: title,
        description: title,
        bubbles: this.intersection.bubbles
      }

      this.addBubbleFromIntersection({bubble}).then(() => {
        this.$notify({
          title: 'Success',
          message: this.$root.$t('notifications.bubble.added'),
          type: 'success'
        })
      }).catch((response) => {
        this.$notify.error({
          title: this.$root.$t('api.' + response.code + '.title'),
          message: this.$root.$t('api.' + response.code + '.message')
        })
      })
    },

    exportCSV () {
      this.loadingExport = true

      HTTP.axios.post(process.env.API + '/bubble/export/bubbles/inters/', {bubbles: this.intersection.bubbles}).then((json) => {
        this.loadingExport = false
        this._downloadCSV(json.data, this.bubble.name)
      }).catch(() => {
        this.loadingExport = false
      })
    }
  }
}

</script>

<style lang="scss" scoped>
  .bubble {
    background: #fff;
    padding: 12px 4px;
    margin: 12px;
    box-shadow: 0 0.1rem 0.5rem rgba(0, 0, 0, 0.08);
    direction: ltr;
    position: relative;
    align-items: center;
    font-size: 14px;
    display: grid;
    border-bottom: 1px solid #dedede;
    grid-template-columns: 20px 1fr 24px;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 4px;
    grid-template-areas:
      "color name actions"
      "color users actions"
      ;

    &.horizontal {
      // display: inline-block;
    }

    .name {
      font-weight: 600;
      grid-area: name;
      margin-right: 6px;
    }
    .color {
      grid-area: color;
      text-align: center;
      height: 100%;
      width: 4px;
      margin-left:6px;
      border-radius: 2px;
    }
    .users {
      grid-area: users;
      > span {
        background: #eaeaea;
        color: #565656;
      }
    }
    .actions {
      grid-area: actions;
    }

    .loading-actions {
      width: 16px;
      height: 16px;
      position: absolute;
      bottom: 8px;
      right: 8px;
      color: #aeaeae;
      font-size: 16px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bubbles/bubble-intersection.vue